{
  "OninboundalertingPara": "È possibile attivare allarmi quando le chiamate in entrata rimangono in attesa per troppo tempo.",
  "OntalktimePara": "È inoltre possibile attivare allarmi quando una chiamata raggiunge una soglia di tempo di conversazione.",
  "OninboundalertingLabel": "Su Allarme in entrata Over:",
  "OntalktimeLabel": "In tempo di conversazione, il tempo è scaduto:",
  "OninboundalertingEnabledHiddenlabel": "L'impostazione di avviso in entrata è attivata?",
  "OntalktimeEnabledHiddenlabel": "L'impostazione On Talk Time Over è abilitata?",
  "OninboundalertingPlaceholder": "15s",
  "OntalktimePlaceholder": "5m 0s",
  "CallStateThresholds_SectionHeader": "Soglie dello stato di chiamata",
  "NAME": "CallStateThresholds"
}